import React, { Component } from "react";

import { initTokenTimeout } from "../../utils/TokenRefresh";

export default class IdleTimerHandler extends Component {
    componentDidMount() {
        initTokenTimeout();
    }

    render() {
        return null;
    }
}



// WEBPACK FOOTER //
// ./src/components/idle-timer/IdleTimerHandler.js